import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: '他社で購入したDJI製ドローンも修理してもらえますか？',
      answer: 'はい、対応可能です。IDS佐賀教習所はDJI推薦修理センターのため、他社で購入された機体でも修理を承ります。保証期間内で製品起因の故障であれば無償修理、保証期間外やユーザー起因の破損は有償修理となります。'
    },
    {
      question: '緊急修理はどのくらいで対応してもらえますか？',
      answer: '故障内容と部品在庫状況によりますが、グループ3拠点で連携し、可能な限り迅速に対応いたします。部品共有ネットワークにより、最短での修理完了を目指します。まずはお電話またはお問い合わせフォームからご連絡ください。'
    },
    {
      question: '修理費用の見積もりは無料ですか？',
      answer: 'はい、見積もりは無料です。機体をお持ちいただければ、DJI認定整備士が診断し、修理内容と費用のお見積もりをご提示いたします。'
    },
    {
      question: '修理中に代替機を借りることはできますか？',
      answer: '代替機のご用意については、在庫状況により対応可能な場合がございます。散布シーズンなど繁忙期のご利用をご検討の場合は、事前に各拠点へご相談ください。'
    },
    {
      question: '無償修理の対象かどうか、どうやって判断されますか？',
      answer: 'DJI推薦修理センター（IDS佐賀教習所）では、DJIから付与された「無償判定権限」に基づき判断いたします。保証期間、製品状態、故障原因を総合的に診断し、無償修理対象かをお伝えします。墜落の場合も飛行データ解析により製品起因と判断されれば無償対応となります。'
    },
    {
      question: '年次点検の保険は、どのような補償内容ですか？',
      answer: '年次点検を受けていただくと、損害賠償保険が無償で付帯されます。対人補償は最大1億円、対物補償は最大5,000万円、管理財物の修理費用も補償されます。追加補償者特約により、ドローンを貸与した場合も借主が補償対象になります。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            よくある質問
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-blue-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
